export default __webpack_public_path__ + "static/project-banner-54c64613d9665ce03c5c153d2c2442e3.jpg";